import { green, red, yellow, magenta, orange, purple } from 'globals/colors';

// eslint-disable-next-line import/prefer-default-export
export const getAvatarColor = (idx: number): string => {
  switch (idx) {
    case 0:
      return green.V2;
    case 1:
      return red.V2;
    case 2:
      return yellow.V2;
    case 3:
      return magenta.V2;
    case 4:
      return orange.V2;
    case 5:
      return purple.V2;
    default:
      return green.V2;
  }
};
